import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ArrayModel, assignModelOptions, ExpenseModel, NotificationIdentifierModel } from '@evorait/pace-core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-expenses-list',
    templateUrl: './expenses-list.component.html',
    styleUrls: ['./expenses-list.component.scss'],
    standalone: false,
})
export class ExpensesListComponent implements OnInit {
    @Input()
    public notificationIdentifier: NotificationIdentifierModel;

    @Input()
    public expenses: ArrayModel<ExpenseModel>;

    @Input()
    public parentForm: FormArray;

    @Input()
    public readonly: boolean | undefined;
    public currency: string;
    public faTrashAlt = faTrashAlt;
    public constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

    public ngOnInit(): void {
        if (typeof this.readonly === 'undefined') {
            this.readonly = false;
        }
        this.expenses.value.forEach((expense) => {
            expense.expenseValue = assignModelOptions(
                expense.expenseValue,
                {
                    ...expense.expenseValue.options,
                    readonly: this.readonly || false,
                },
                expense,
            );
            expense.expenseCode = assignModelOptions(
                expense.expenseCode,
                {
                    ...expense.expenseCode.options,
                    disabled: this.readonly || false,
                },
                expense,
            );
        });
    }

    /**
     * To delete a row of expense. Calls the removeModel method of the ArrayModel
     *
     * @param {number} index - The index of the expense to be deleted.
     */
    public deleteExpense(index: number): void {
        this.expenses.removeModel(index);
        this.changeDetectorRef.detectChanges();
    }

    /**
     * Add new expense row for the notification. Calls the AddModel method of the ArrayModel.
     * Initially expenseType and expenseValue is blank.
     */
    public addNewExpense(): void {
        const expenseModel = new ExpenseModel(this.notificationIdentifier);
        this.expenses.addModel(expenseModel);
        this.changeDetectorRef.detectChanges();
    }
}
